<template>
  <v-dialog transition="dialog-top-transition" max-width="80%" :style="{ borderRadius: '25px' }" v-model="showDialog">
    <v-card>
      <div :style="{ display: 'flex' }">
        <v-col cols="1" class="logo-box" :style="{ background: logoBackgroundColor }">
          <img src="../../assets//BM_Logo_Full_Size.svg" alt="Description of image" class="absolute-center-right" />
        </v-col>
        <v-col cols="3" style="overflow: auto" class="pr-0 dashborder">
          <h3 class="check-Winner-h3 mb-3">Check Winner</h3>
          <div id="list-demo  mt-4" :class="containerClass">
            <!-- <transition-group name="list" class="number-grid"> -->
            <div v-for="(number, index) in totalBoxes" :key="`box-${index}`" class="list-item rounded-circle"
              :style="{ backgroundColor: index < numbers.length ? '#fa3717' : '#E7E7E7' }">
              {{ numbers[index] }}
            </div>
          </div>
        </v-col>
        <!-- TODO - Fix v-for to use objects not hard coded numbers -->
        <v-col :cols="8" class="paddingCols">
          <h3 class="check-Winner-h3 mb-3">{{ getCurrentWinningPatternText }}</h3>
          <div class="mt-4" :style="{ border: '1px solid #DBDBDB' }">
            <v-row v-for="n in 3" :key="n" class="ml-0 mr-0 pa-0 mt-0 mb-0">
              <v-col v-for="m in 9" :key="m" class="text-center solid-border pa-0 ">
                <template v-if="getGridItem(n, m)">
                  <div class="winnerNumberBox" :style="{ background: backgroundColour(getGridItem(n, m)) }">
                    {{ getGridItem(n, m) }}
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>

          <v-row class="mt-4">
            <v-col cols="6" :style="{ display: 'flex', justifyContent: 'center', borderRight: '1px solid #DEDEDE' }">
              <div :style="{ display: 'flex' }" class="current-padding">
                <h3 class="currentWinnerh3">Current Number:</h3>
                <span class="currentWinnerNumberBox ms-3">{{
                  getCurrentNumber
                }}</span>
              </div>
            </v-col>
            <v-col cols="6">
              <div :style="{ display: 'flex', justifyContent: 'center' }" class="current-padding">
                <h3 class="currentWinnerh3">Winning Panel:</h3>
                <span v-if="verifiedPanel || panelId"
                  :class="{ 'currentWinnerNumberBoxWinner ms-3': verifiedPanel || panelId }">
                  {{ playerView ? verifiedPanel : panelId }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </div>
 
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "VerificationDialog",
  data: () => ({
    numbers: [],
    panelId: null, 
  }),
  props: {
    playerView: {
      type: Boolean,
      required: false,
      default: false,
    },
    verifiedPanel: {
      type: Number,
      required: false,
      default: null,
    },
    fontSize: {
      type: String,
      reqiured: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters([
      "getShowVerificationBoard",
      "getDrawnNumbers",
      "getCheckedPanel",
      "getCurrentNumber",
      "getActiveGame",
      "getGameWon",
      "getCurrentWinningPatternText",
    ]),
    logoBackgroundColor() {
        return this.getActiveGame &&
        this.getActiveGame.colour &&
        this.getActiveGame.colour.attributeValue
        ? this.getActiveGame.colour.attributeValue
        : '#f97d69';
    },
    showDialog: {
      get() {
        return this.getShowVerificationBoard;
      },
      set(show) {
        this.setShowVerificationBoard(show);
      },
    },
    enableVerifyButton() {
      return this.panelId && this.getGameWon;
    },
    activePanel() {
      let rows = [];
      if (!this.getCheckedPanel.perm) {
        return [];
      }
      for (let i = 0; i < 3; i++) {
        let row = [];
        for (let j = 0; j < 18; j = j + 2) {
          let loopIndex = j + i * 18;
          row.push(
            this.getCheckedPanel.perm.substring(loopIndex, loopIndex + 2)
          );
        }
        rows.push(row);
      }
      return rows;
    },
    containerClass() {
      return this.numbers.length > 50 ? "grid-8" : "grid-4";
    },
    totalBoxes() {
      return this.numbers.length > 50 ? 90 : 50; // 50 or 90 boxes logic
    }
  },
  methods: {
    ...mapActions([
      "setShowVerificationBoard",
      "fetchPanel",
      "clearCheckedPanel",
      "setWinnerVerified",
    ]),
    showNumbers() {
      for (let i = 0; i < this.getDrawnNumbers.length; i++) {
        this.numbers.unshift(this.getDrawnNumbers[i]);
      }
    },
    backgroundColour(number) {
      if (this.getCurrentNumber && this.getCurrentNumber == number) {
        return "#2BBE1E";
      } else if (this.getDrawnNumbers.includes(number * 1)) {
        return "#FB3615";
      } else {
        return "#E7E7E7";
      }
    },
    checkPanel(panelId) {
      if (this.numbers.length == 0) {
        this.showNumbers();
      }
      this.fetchPanel(panelId);
    },
    getGridItem(n, m) {
      if (!this.activePanel.length > 0) {
        return null;
      } else if (this.activePanel[n - 1][m - 1] == "00") {
        return "";
      }
      return this.activePanel[n - 1][m - 1];
    },
    winnerVerified() {
      this.setWinnerVerified(this.panelId);
      this.showDialog = false;
    },
  },
  watch: {
    showDialog(show) {
      this.clearCheckedPanel();
      if (show == false) {
        this.panelId = null;
        this.numbers = [];
      } else {
        if (this.playerView && this.verifiedPanel) {
          const checkFunc = this.checkPanel;
          const panelId = this.verifiedPanel;
          setTimeout(function () {
            checkFunc(panelId);
          }, 300);
        }
      }
    },
  },
};
</script>

<style scoped>
.dashborder {
  border-right: 3px dashed #e5e5e5;
}

.grid-4 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px 0px;
}

.grid-8 {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px 0px;
}

.v-sheet.v-card {
  border-radius: 25px !important;
}

.logo-box {
  border-radius: 25px 0px 0px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-Winner-h3 {
  color: #1e1e1e;
  font-family: "Arial Rounded MT Bold";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
}

/* .number-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
} */
.grid-4 .list-item {
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  font-family: "Arial Rounded MT Bold";
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: #fa3717;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-8 .list-item {
  width: 25px;
  height: 25px;
  background-color: #fa3717;
  text-align: center;
  color: #fff;
  text-align: center;
  font-family: "Arial Rounded MT Bold";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
}

.winnerNumberBox {
  display: flex;
  width: 58px;
  height: 58px;
  /* padding: 16px 15px; */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 68px;
  box-shadow: -1px -3px 7.4px 0px rgba(150, 150, 150, 0.39) inset,
    9px 10px 6.5px 0px rgba(198, 198, 198, 0.12) inset;
  color: #fff;
  text-align: center;
  font-family: "Arial Rounded MT Bold";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
}

.list-enter-active,
.list-leave-active {
  transition: all 1.5s;
}

.paddingCols {
  padding-left: 12px;
}

.list-enter,
.list-leave-to

/* .list-leave-active below version 2.1.8 */
  {
  opacity: 0;
  transform: translateY(-100px);
}

.list-move {
  transition: transform 0.2s;
}

.solid-border {
  border: 1px solid #dbdbdb;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}

.currentWinnerh3 {
  color: #393939;
  font-family: "Arial Rounded MT Bold";
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
}

.currentWinnerNumberBox {
  border-radius: 16px;
  background: #f9eac8;
  color: #1e1e1e;

  text-align: right;
  font-family: "Arial Rounded MT Bold";
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  padding: 0px 8px;
}

.currentWinnerNumberBoxWinner {
  border-radius: 16px;
  background: #ffddd7;
  color: #1e1e1e;
  text-align: right;
  font-family: "Arial Rounded MT Bold";
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  padding: 0px 8px;
  display: flex;
    justify-content: center;
    align-items: center;
}

@media (min-width: 2100px) and (max-width: 2800px) {
  .check-Winner-h3 {
    color: #1e1e1e;
    font-family: "Arial Rounded MT Bold";
    font-size: 36px;
    font-style: normal;
    font-weight: 400;
  }


  .grid-8 .list-item {
    width: 45px;
    height: 45px;
    background-color: #fa3717;
    text-align: center;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .grid-4 {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 6px 0px;
  }

  .grid-8 {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 8px 0px;
  }

  .absolute-center-right {
    width: 113px;
  }

  .grid-4 .list-item {
    width: 60px;
    height: 60px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 33px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background-color: #fa3717;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .solid-border {
    border: 1px solid #dbdbdb;
    min-height: 154px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .winnerNumberBox {
    display: flex;
    width: 90px;
    height: 90px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 68px;
    box-shadow: -1px -3px 7.4px 0px rgba(150, 150, 150, 0.39) inset, 9px 10px 6.5px 0px rgba(198, 198, 198, 0.12) inset;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
  }

  .currentWinnerh3 {
    color: #393939;
    font-family: "Arial Rounded MT Bold";
    font-size: 36px;
    font-style: normal;
    font-weight: 400;
  }

  .currentWinnerNumberBox {
    border-radius: 16px;
    background: #f9eac8;
    color: #1e1e1e;
    text-align: right;
    font-family: "Arial Rounded MT Bold";
    font-size: 31px;
    font-style: normal;
    font-weight: 400;
    padding: 0px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media (min-width: 3100px) and (max-width: 3850px) {
  .check-Winner-h3 {
    color: #1e1e1e;
    font-family: "Arial Rounded MT Bold";
    font-size: 57px;
    font-style: normal;
    font-weight: 400;
  }


  .grid-8 .list-item {
    width: 40px;
    width: 60px;
    height: 60px;
    background-color: #fa3717;
    text-align: center;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .grid-4 {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 10px 14px;
    padding: 10px;
  }

  .grid-8 {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 8px 0px;
    padding: 10px;
  }

  .absolute-center-right {
    width: 160px;
  }

  .grid-4 .list-item {
    width: 90px;
    height: 90px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 49px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background-color: #fa3717;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .solid-border {
    border: 1px solid #dbdbdb;
    min-height: 215px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .winnerNumberBox {
    display: flex;
    width: 140px;
    height: 140px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 68px;
    box-shadow: -1px -3px 7.4px 0px rgba(150, 150, 150, 0.39) inset, 9px 10px 6.5px 0px rgba(198, 198, 198, 0.12) inset;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 80px;
    font-style: normal;
    font-weight: 400;
  }

  .currentWinnerh3 {
    color: #393939;
    font-family: "Arial Rounded MT Bold";
    font-size: 65px;
    font-style: normal;
    font-weight: 400;
  }

  .currentWinnerNumberBox {
    border-radius: 16px;
    background: #f9eac8;
    color: #1e1e1e;
    text-align: right;
    font-family: "Arial Rounded MT Bold";
    font-size: 54px;
    font-style: normal;
    font-weight: 400;
    padding: 0px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .currentWinnerNumberBoxWinner {
  border-radius: 16px;
  background: #ffddd7;
  color: #1e1e1e;
  text-align: right;
  font-family: "Arial Rounded MT Bold";
  font-size: 54px;
  font-style: normal;
  font-weight: 400;
  padding: 0px 8px;
  display: flex;
    justify-content: center;
    align-items: center;
}
  .paddingCols[data-v-3fc0d2c0] {
    padding: 12px 26px 12px 26px;
  }
}

@media (min-width: 7380px) and (max-width: 7700px) {
  .check-Winner-h3 {
    color: #1e1e1e;
    font-family: "Arial Rounded MT Bold";
    font-size: 121px;
    font-style: normal;
    font-weight: 400;
    padding: 36px;
  }


  .grid-8 .list-item {
    width: 150px;
    height: 150px;
    background-color: #fa3717;
    text-align: center;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 90px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .grid-4 {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 30px 14px;
    padding: 33px 18px 51px 20px;
  }

  .grid-8 {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 19px 0px;
    padding: 33px 18px 51px 20px;
  }

  .absolute-center-right {
    width: 360px;
  }

  .grid-4 .list-item {
    width: 200px;
    height: 200px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 119px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background-color: #fa3717;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .solid-border {
    border: 1px solid #dbdbdb;
    min-height: 550px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .winnerNumberBox {
    display: flex;
    width: 290px;
    height: 290px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 174px;
    box-shadow: -1px -3px 7.4px 0px rgba(150, 150, 150, 0.39) inset, 9px 10px 6.5px 0px rgba(198, 198, 198, 0.12) inset;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 170px;
    font-style: normal;
    font-weight: 400;
  }

  .currentWinnerh3 {
    color: #393939;
    font-family: "Arial Rounded MT Bold";
    font-size: 160px;
    font-style: normal;
    font-weight: 400;
  }

  .currentWinnerNumberBox {
    border-radius: 32px;
    background: #f9eac8;
    color: #1e1e1e;
    text-align: right;
    font-family: "Arial Rounded MT Bold";
    font-size: 166px;
    font-style: normal;
    font-weight: 400;
    padding: 0px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .currentWinnerNumberBoxWinner {
  border-radius: 16px;
  background: #ffddd7;
  color: #1e1e1e;
  text-align: right;
  font-family: "Arial Rounded MT Bold";
  font-size: 166px;
  font-style: normal;
  font-weight: 400;
  padding: 0px 8px;
  display: flex;
    justify-content: center;
    align-items: center;
}
  .paddingCols[data-v-3fc0d2c0] {
    padding: 12px 52px 12px 56px;
  }

  .current-padding {
    padding-top: 50px;
  }
}
</style>